import React, { useState, useEffect } from "react";
import Navbarside from "../Navbarside";
import Footer from "../footer";
import { toast, ToastContainer } from "react-toastify";
import { useLocation, useNavigate, useParams, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import moment from 'moment';
import { Card, CardHeader, CardContent } from '@mui/material';
import axios from 'axios';

const ProcessEnquiry = () => {
  const location = useLocation();
  const [companyData, setCompanyData] = useState({})

  const navigate = useNavigate("");
  const dispatch = useDispatch();

  const cancel = () => navigate(-1);
  useEffect(() => {

    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get('id');
    console.log({ id })

    axios.get(`https://api.healthonify.com/get/company?id=${id}`).then(res => {
      setCompanyData(res.data.data[0])
    }).catch(({ message }) => {
      alert(message)
    })

  }, [dispatch]);

  const showErrorToast = (message) => {
    toast.error(message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 4000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false
    });
  };

  // const handleExpertiseChange = e => setSelectedExpertise(e.target.value)
  // const handleSubExpertiseChange = e => setSelectedSubExpertise(e.target.value)

  return (
    <body data-col="2-columns" className=" 2-columns ">
      <Navbarside />
      <div className="container-fluid pb-5 response-cover">
        <div className="row">
          <div className="col-lg-2 col-md-4" />
          <div className="col-lg-10 col-md-8">
            <div className="container-fluid pt-5">
              <div className="card">
                <Card variant='outlined'>
                  <CardHeader title="Company Details" />
                  <CardContent>

                    <Link
                      to={`/MembershipAnalysis?corporateAdminId=${companyData.adminId}`}
                      className="btn btn-primary"
                    >
                      View Subscribed Packages
                    </Link>
                    &nbsp;
                    <Link
                      to={`/SessionAnalysis?corporateAdminId=${companyData.adminId}`}
                      className="btn btn-primary"
                    >
                      View Consumed Sessions
                    </Link>

                    {companyData
                      ? Object.keys(companyData).map((x, i) => {
                        if (
                          x != "_id"
                          && x != "__v"
                          && x != "source"
                          && x != "flow"
                          && x != "updated_at"
                          && x != "ticketNumber"
                          && x != "status"
                          && x != "isActive"
                          && x != "disabled"
                        ) {
                          return <p> {x} : {companyData[x]}</p>
                        }
                        else return ''
                      })
                      : ''
                    }
                  </CardContent>
                </Card>
              </div>

            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
      <Footer />
    </body>
  );
};

export default ProcessEnquiry;
